import { AppTeamUtil } from '../../core/app-team-util';

export class ActionReportDailyInfo
{
	Date!: Date;
	ActionCount!: number;

	constructor(json?: any)
	{
		this.Date = AppTeamUtil.convertApiDateStringToDate(json['Date'])!;
		this.ActionCount = json.ActionCount;
	}
}

export class ActionReportData
{
	DailyInfo!: ActionReportDailyInfo[];
	UniqueUserCount!: number;

	constructor(json?: any)
	{
		this.UniqueUserCount = json.UniqueUserCount;
		this.DailyInfo = json.DailyInfo.map((itemJson: any) => new ActionReportDailyInfo(itemJson));
	}
}
